import { Box, Typography, Container } from '@mui/material';
import Wallpaper from '../assets/clover.jpg';

const Business = () => {
  return (
    <Container
      disableGutters
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        // 👈 SE対策：高さを固定せず、最低全画面を確保
        minHeight: "100vh",
        width: "100%",
        boxSizing: 'border-box',
      }}
    >
      {/* 左側：画像セクション */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          position: "relative",
          backgroundImage: `url(${Wallpaper})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          padding: 2,
          marginTop: { xs: "64px", md: 0 }, 
          minHeight: { xs: "100px", md: "auto" }, 
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.2)", // 👈 少し暗くして文字を読みやすく
            backdropFilter: "blur(4px)",
            zIndex: 1,
          }}
        />

        <Box sx={{ position: "relative", zIndex: 2, color: "white" }}>
          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: "32px", md: "40px" }, 
              fontWeight: "bold",
              fontFamily: "'Noto Serif JP', serif",
            }}
          >
            Business
          </Typography>
          <Typography 
            variant="h6" 
            sx={{ 
              fontFamily: "'Noto Serif JP', serif",
              fontSize: { xs: "1rem", md: "1.2rem" },
              opacity: 0.9
            }}
          >
            事業内容
          </Typography>
        </Box>
      </Box>

      {/* 右側：テキストセクション */}
      <Box
        sx={{
          flex: 2,
          display: "flex",
          flexDirection: "column",
          // 👈 XRでは中央、SEで溢れるなら上から配置
          justifyContent: "center",
          padding: { xs: 3, md: 8 },
          // 👈 これがRecruit/Contactと同じ中央寄せの魔法
          my: { xs: 0, md: 'auto' }, 
        }}
      >
        <Box sx={{ my: 'auto' }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "18px", md: "26px" }, 
              fontFamily: "'Noto Serif JP', serif",
              marginBottom: "16px",
              display: 'flex',
              alignItems: 'center',
              '&::before': {
                content: '""',
                width: '4px',
                height: '24px',
                backgroundColor: '#000',
                marginRight: '12px',
                display: { xs: 'none', md: 'block' }
              }
            }}
          >
            ITソリューション事業
          </Typography>
          
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: "15px", md: "18px" }, 
              fontFamily: "'Noto Serif JP', serif",
              textAlign: "left",
              lineHeight: 1.8,
              marginLeft: { xs: 0, md: "16px" },
            }}
          >
            Java, Rubyが得意な開発系エンジニアをアサインし、
            お客様のシステム開発をサポートします。
            <br /><br />
            また豊富な実績のあるパートナー企業のご協力により、
            案件のフェーズや技術スタックに合わせた
            適切なエンジニアを現場にアサインします。
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default Business;
